import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useRef } from 'react';
import { propFunc, propStr, } from '../../../../../../../helpers/custom-prop-types';
import { useInputBlurOnEnter } from '../../../../../../../helpers/use/useInput';
import SearchSimpleIcon from '../../../../../../Icon/Svg/SearchSimpleIcon';
const FilterKeyword = (props) => {
    const { defaultKeywordValue, onBlurKeyword, placeholder } = props;
    const ref = useRef();
    const onKeyDown = useInputBlurOnEnter(ref);
    return (_jsxs("div", Object.assign({ className: 'keyword_box' }, { children: [_jsx(SearchSimpleIcon, { className: '' }), _jsx("input", { className: 'input_keyword_box', defaultValue: defaultKeywordValue, onBlur: onBlurKeyword, onKeyDown: onKeyDown, placeholder: placeholder, ref: ref, type: 'search' })] })));
};
FilterKeyword.propTypes = {
    defaultKeywordValue: propStr().isRequired,
    onBlurKeyword: propFunc().isRequired,
    placeholder: propStr(),
};
FilterKeyword.defaultProps = {
    placeholder: '検索',
};
export default FilterKeyword;
